<div class="sms-test-page">
  <div class="sms-test-card">
    <h2 class="page-title">Send Test SMS</h2>
    <p class="page-subtitle">Send an SMS directly from any Twilio number for testing purposes.</p>

    <form [formGroup]="form" (ngSubmit)="send()" class="sms-form">

      <div class="form-group">
        <label for="from">From <span class="required">*</span></label>
        <input id="from" type="text" pInputText formControlName="from"
          placeholder="+19175550000 (Twilio number)" class="w-100" />
        <small class="field-error" *ngIf="form.get('from')?.invalid && form.get('from')?.touched">
          From number is required.
        </small>
      </div>

      <div class="form-group">
        <label for="to">To <span class="required">*</span></label>
        <input id="to" type="text" pInputText formControlName="to"
          placeholder="+12025551234 (recipient)" class="w-100" />
        <small class="field-error" *ngIf="form.get('to')?.invalid && form.get('to')?.touched">
          To number is required.
        </small>
      </div>

      <div class="form-group">
        <label for="body">Message <span class="required">*</span></label>
        <textarea id="body" pInputTextarea formControlName="body" rows="5"
          class="w-100" placeholder="Type your message here..."
          [maxlength]="1600"></textarea>
        <small [ngClass]="bodyLength >= 1600 ? 'text-danger' : 'text-muted'">
          {{ bodyLength }}/1600 characters
        </small>
        <small class="field-error" *ngIf="form.get('body')?.invalid && form.get('body')?.touched">
          Message is required.
        </small>
      </div>

      <p-button type="submit" label="Send SMS" icon="pi pi-send"
        class="primary-btn send-btn" styleClass="w-100"
        [loading]="isSending"
        [disabled]="isSending">
      </p-button>

    </form>

    <!-- Success result -->
    <div class="result-card success-card" *ngIf="result">
      <div class="result-icon"><i class="pi pi-check-circle"></i></div>
      <div class="result-body">
        <strong>SMS sent successfully</strong>
        <div class="result-detail"><span class="label">SID:</span> {{ result.sid }}</div>
        <div class="result-detail"><span class="label">Status:</span> {{ result.status }}</div>
      </div>
    </div>

    <!-- Error result -->
    <div class="result-card error-card" *ngIf="errorMessage">
      <div class="result-icon"><i class="pi pi-times-circle"></i></div>
      <div class="result-body">
        <strong>Failed to send</strong>
        <div class="result-detail">{{ errorMessage }}</div>
      </div>
    </div>

  </div>
</div>
